
import React, {useEffect} from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";
import About from './About';
import Team from './Team';
import UpcomingEvents from './UpcomingEvents';
import Achievement from './Achievement';
import Donation from './Donation';
import Partner from './Partner';
import Footer from './Footer';
import Header from './Header';
import Contact from './Contact';
import Banner from './Banner';
import Gallery from './Gallery';
import Home from './Home';

 function HomePage(props) {
    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);
    
    return (
<>

<section id="section1"><Header /></section>
<Banner />
<Home />
<section id='section2'><About /></section>
{/* <Team /> */}
<section id='section3'><UpcomingEvents /></section>
<section id='section4'><Achievement /></section>
<section id='section5'><Gallery /></section>
<section id='section6'><Partner /></section>
<section id='section7'><Donation /></section>
<section id='section8'><Contact /></section>
<Footer />
</>

    )

}

export default HomePage
